import TrackerIcon from './TrackerIcon.vue'
import TimeIcon from './TimeIcon.vue'
import BatteryIcon from './BatteryIcon.vue'
import SpeedIcon from './SpeedIcon.vue'
import LocationIcon from './LocationIcon.vue'
import PersonIcon from './PersonIcon.vue'
import PhoneIcon from './PhoneIcon.vue'

export { TrackerIcon, TimeIcon, BatteryIcon, SpeedIcon, LocationIcon, PersonIcon, PhoneIcon }

export default {
  tracker: {
    component: TrackerIcon,
    color: 'bg-blue-600',
    label: 'Tracker',
  },
  time: {
    component: TimeIcon,
    color: 'bg-purple-600',
    label: 'Laatst gezien',
  },
  battery: {
    component: BatteryIcon,
    color: 'bg-green-600',
    label: 'Batterij',
  },
  speed: {
    component: SpeedIcon,
    color: 'bg-red-600',
    label: 'Snelheid',
  },
  location: {
    component: LocationIcon,
    color: 'bg-blue-400',
    label: 'Locatie',
  },
  person: {
    component: PersonIcon,
    color: 'bg-blue-300',
    label: 'Persoon',
  },
  phone: {
    component: PhoneIcon,
    color: 'bg-blue-400',
    label: 'Telefoon',
  },
}
